export default __webpack_public_path__ + "static/media/impressions.cf353f3a.png";